import React from "react";
import PurchaseReturnTable from "./PurchaseReturnTable";

const index = () => {
  return (
    <div>
      <PurchaseReturnTable />
    </div>
  );
};

export default index;
